import app from 'flarum/forum/app';
import ContactForm from './components/ContactForm';
import MinifigDecoder from './components/MinifigDecoder';

// Export the components as modules
export const components = {
    ContactForm: ContactForm,
    MinifigDecoder: MinifigDecoder
};

app.initializers.add('brickzip-pages-components', () => {
    // Register as a module
    (window as any).flarum.extensions['brickzip-pages-components'] = {
        __esModule: true,
        'default': components,
        ...components
    };
    
    console.log('Extension registered:', (window as any).flarum.extensions['brickzip-pages-components']);
}, -100);
